import { lazy, Suspense, useEffect } from 'react';
/// Components
import { connect, useDispatch } from 'react-redux';
import { Route, Routes, useLocation, useNavigate, useParams } from 'react-router-dom';
import Index from './jsx/index';
// action
import { checkAutoLogin } from './services/AuthService';
import { isAuthenticated } from './store/selectors/AuthSelectors';
/// Style
import axios from 'axios';
import "./css/style.css";
import ErrorTest from './jsx/pages/ErrorTest';
import "./other/bootstrap-select/dist/css/bootstrap-select.min.css";
import './other/swiper/css/swiper-bundle.min.css';


const SignUp = lazy(() => import('./jsx/pages/Registration'));
const Login = lazy(() => {
    return new Promise(resolve => {
        setTimeout(() => resolve(import('./jsx/pages/Login')), 500);
    });
});

function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        let location = useLocation();
        let navigate = useNavigate();
        let params = useParams();

        return (
            <Component
                {...props}
                router={{ location, navigate, params }}
            />
        );
    }

    return ComponentWithRouterProp;
}

function App(props) {

    // axios.defaults.headers.common['userId'] = JSON.parse(localStorage.getItem('userDetails'))?.userId;
    // axios.defaults.headers.common['adminId'] = JSON.parse(localStorage.getItem('userDetails'))?.adminId
    axios.defaults.headers.common['Authorization'] = JSON.parse(localStorage.getItem('userDetails'))?.idToken;
    axios.defaults.headers.common['email'] = JSON.parse(localStorage.getItem('userDetails'))?.EmailId;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const currentLocation = useLocation();
    useEffect(() => {
        if (currentLocation.pathname !== '/history-sub') {
            checkAutoLogin(dispatch, navigate);
        }
    }, [currentLocation.pathname]);

    let routeblog = (
        <Routes>
            <Route path='/login' element={<Login />} />
            <Route path='/page-register' element={<SignUp />} />
            <Route path='/history-sub' element={<ErrorTest />} />
        </Routes>
    );
    if (props.isAuthenticated) {
        return (
            <>
                <Suspense fallback={
                    <div id="preloader">
                        <div className="sk-three-bounce">
                            <div className="sk-child sk-bounce1"></div>
                            <div className="sk-child sk-bounce2"></div>
                            <div className="sk-child sk-bounce3"></div>
                        </div>
                    </div>
                }
                >
                    <Index />
                </Suspense>
            </>
        );

    } else {
        return (
            <div className="vh-100">
                <Suspense fallback={
                    <div id="preloader">
                        <div className="sk-three-bounce">
                            <div className="sk-child sk-bounce1"></div>
                            <div className="sk-child sk-bounce2"></div>
                            <div className="sk-child sk-bounce3"></div>
                        </div>
                    </div>
                }
                >
                    {routeblog}
                </Suspense>
            </div>
        );
    }
};

const mapStateToProps = (state) => {
    return {
        isAuthenticated: isAuthenticated(state),
    };
};

export default withRouter(connect(mapStateToProps)(App)); 